// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"80":"ca444e12","100":"09a8a4c7","264":"64b9ecb4","267":"7162ae2c","403":"72eb0b17","448":"f78db07e","639":"fa2da9aa","645":"2aea8499","783":"2da024bb","900":"4ae305aa","921":"72f7500f","966":"94e32b9c"}[chunkId] + ".js";
};